import React, { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";
import { Link } from "react-router-dom";

const ActionColor = {
  danger: "text-red-700 hover:bg-red-100",
  primary: "text-blue-700 hover:bg-blue-100",
};

export type MenuActionItem = {
  label: string;
} & (
  | { type: "LINK"; to: string }
  | {
      type: "BUTTON";
      onClick: () => void;
      color: keyof typeof ActionColor;
    }
);

export type Props = {
  actions: MenuActionItem[];
};

export const MenuActions = ({ actions = [] }: Props) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <FiMoreVertical
        className="cursor-pointer text-gray-600 hover:text-gray-900"
        size={20}
        onClick={() => setOpen((o) => !o)}
      />

      {open && (
        <ul className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-10 list-none pl-0">
          {actions.length === 0 ? (
            <li className={"px-4 py-2 text-sm "}>No Action Provided</li>
          ) : (
            actions.map((action, idx) =>
              action.type === "BUTTON" ? (
                <li
                  key={idx}
                  className={"px-4 py-2 text-sm cursor-pointer " + ActionColor[action.color]}
                  onClick={() => {
                    action.onClick();
                    setOpen(false);
                  }}
                >
                  {action.label}
                </li>
              ) : (
                <li key={idx} className={"px-4 py-2 text-sm cursor-pointer hover:bg-blue-50"}>
                  <Link to={action.to} className="no-underline">
                    {action.label}
                  </Link>
                </li>
              )
            )
          )}
        </ul>
      )}
    </div>
  );
};
